import Http from "../fx/Http";

class UserApi {
    login(data) {
        return Http.post('/system/user/login', data).
        then((resp)=>{
            if(resp.isSuccess()) {
                localStorage.setItem('system-token', resp.getData("system-token"));
            }
            return resp;
        });
    }

    logout() {
        localStorage.removeItem('system-token')
        // uni.setStorageSync('user', JSON.stringify({}));
        // uni.setStorageSync('token', '');
    }
    info() {
        return Http.post('/mall/mp/member/info');
    }
}
export default new UserApi();



// WEBPACK FOOTER //
// ./src/apis/UserApi.js